import "./Intro.scss";
import Container from "@material-ui/core/Container";
import private_png from "../../Assets/Images/Private 25Jun2021.png";
import cube from "../../Assets/Images/cube.png";

const Intro = (props) => {
  return (
    <div className="intro-container">
      <Container>
        <div className="intro">
          <div className="cube">
            <img
              src={cube}
              alt="Cube"
              width={1045}
              height={1101}
              decoding="async"
            />
          </div>
          <div className="text-container">
            <div className="heading">
              <span>
                Build <span className="underline">“Zero Liability”</span>{" "}
                Products
              </span>
            </div>
            <div className="secure">
              <img
                src={private_png}
                alt="Secure"
                width={646}
                height={123}
                decoding="async"
              />
            </div>
            <div className="subheading">
              <p className="subheading-line subheading-line--problem">
                <span className="subheading-stop">STOP</span> Hiding Keys Under
                the Doormat
              </p>
              <p className="subheading-line subheading-line--solution">
                Structurally Protect Against{" "}
                <span className="subheading-highlight">
                  Claude Mythos
                </span>
              </p>
            </div>
            <div className="text">
              <p>
                Integrate <b>Privacy</b> into your SaaS applications{" "}
                <i>instantly</i> with{" "}
                <u className="cursor-pointer" onClick={props.executeE2EEScroll}>
                  E2EE++
                </u>{" "}
                - and get{" "}
                <u
                  className="cursor-pointer"
                  onClick={props.executeZeroTrustScroll}
                >
                  ZeroTrust++
                </u>{" "}
                <b>Security</b> for your enterprise customers easily.
              </p>
              <p>
                Secure your customers by enabling them to take full control of
                their sensitive data and <i>eliminate</i> liability (vs
                transferring it to somebody else) using Bayun’s
                simple-to-integrate DigiLockbox™ solution.
              </p>
            </div>
            {/* <button onClick={props.executeScroll}>Request a Demo</button> */}
          </div>
        </div>
        <div className="digilock-container">

          <p>
            While keeping user data encrypted has become a standard practice in
            cloud services, the core issue that still remains is the management of encryption keys.
            Invariably, these keys reside in a <i>centralized</i> key-vault controlled

            by the service provider. Even when protected by{" "}
            <a target="_blank" href="https://en.wikipedia.org/wiki/Hardware_security_module">HSMs</a>{" "}
            or{" "}
            <a target="_blank" href="https://cpl.thalesgroup.com/faq/key-secrets-management/what-bring-your-own-key-byok">BYOK</a>
            /CMEK schemes disallowing direct human access, keys still remain
            indirectly accessible to the provider through automated, server-side
            applications for data processing. This <u>always-on</u> access to{" "}
            <u>all</u> the user data by <i>trusted</i> code, executing on{" "}
            <i>trusted</i> servers, managed by <i>trusted</i> admins, is the
            primary vulnerability behind most data breaches - as perfect code
            and human infallibility are impossible to guarantee. So this practice is the digital equivalent of putting a bullet-proof lock on our front door, and then hiding the key under the doormat (or at best, handing it over to a doorman)!
          </p>

          <p>
            No wonder then that, as pointed out by{" "}
            <a target="_blank" href="https://www.apple.com/newsroom/2023/12/report-2-point-6-billion-records-compromised-by-data-breaches-in-past-two-years/">Prof. Madnick from MIT in his recent studies</a>
            , data breaches have become a global epidemic. And the entire cyber defense world faces yet another monumental challenge with the onslaught of advanced AI models like Claude Mythos, which completely tilt the scale in favor of offenders. Proper use of end-to-end encryption (E2EE), like
            that{" "}
            <a target="_blank" href="https://www.apple.com/newsroom/2022/12/apple-advances-user-security-with-powerful-new-data-protections/">adopted by Apple</a>,{" "}
            provides the best structural defense against the rapidly evolving threat landscape, and is the most effective {" "}
            <a target="_blank" href="https://www.lawfaremedia.org/article/personal-data-in-the-cloud-is-under-siege.-end-to-end-encryption-is-our-most-powerful-defense">vaccine to get ourselves out of this epidemic</a>
            .{" "}
            When you explicitly enable <mark style={{ backgroundColor: "#00FFFF" }}>Advanced Data Protection</mark> in your iPhone Settings, you are basically taking away your data keys from Apple (rather than Apple keeping it for you hidden under the doormat). So even though your data is sitting on Apple servers, it is not accessible to anyone else, thus giving you full control with real privacy.
            This imperative for enhanced data privacy and user control is
            further amplified by the{" "}
            <a target="_blank" href="https://iapp.org/resources/article/consumer-perspectives-of-privacy-and-ai/">current AI wave</a>{" "}
            and the increasing demands for {" "}
            <a target="_blank" href="https://cloudsecurityalliance.org/blog/2025/01/06/global-data-sovereignty-a-comparative-overview">data self-sovereignty</a>{" "}globally. No wonder that Apple itself is extending their lead in user data
            privacy from E2EE to{" "}
            <a target="_blank" href="https://security.apple.com/blog/private-cloud-compute/">Apple Intelligence via Private Cloud Compute</a>
            .{" "}
          </p>

          <p>
            DigiLockbox builds upon the principles of Apple’s iCloud Keychain
            security model, encrypting all data with <i>user-controlled</i> keys,
            managed via secure enclaves of their end-devices. It eliminates <i>centralized</i> key-vaults,
            granting full data sovereignty back to the user. Server access is
            strictly limited to small amounts of data, only for immediate
            processing, and for a limited period, thereby minimizing exposure.
            And even this <i>limited</i> exposure during Data in Use can also be
            eliminated completely by using one or more privacy preserving
            techniques for processing data, like Confidential Compute (including even{" "}
            <a target="_blank" href="https://near.ai">Confidential AI</a>
            ), Private
            Cloud Compute, or Homomorphic Encryption. Note that <mark style={{ backgroundColor: "#00FFFF" }}>Zero Data Retention (ZDR)</mark> has already become the de-facto baseline standard for processing of any sensitive customer data by all the AI model providers, in order to comply with security guarantees needed for HIPAA in healthcare, attorney-client privilege in legal, risk minimization in HR or financial services, etc. Thus by making all compute fully stateless (and even unobservable if necessary), and cryptographically securing all state storage with E2EE, we can achieve foolproof{" "}
            <i>end-to-end protection</i> for the <i><b><u>entire</u></b></i> lifecycle of user data from <i>creation,{" "}</i>
            through <i>consumption</i>, and all the way to its <i>destruction</i>. DigiLockbox achieves this by creating a secure,
            virtual lockbox for each user, accessible only from secure enclaves
            of trusted end-devices. It manages multi-factor <u>authorization</u>{" "}
            (not just authentication) that cannot be bypassed, enforcing
            arbitrary access policies through <i>cryptography</i>, and providing
            immunity against brute force, phishing, MITM attacks, privilege
            misuse, and even the{" "}
            <a target="_blank" href="https://www.forbes.com/sites/daveywinder/2025/06/29/11-million-critical-vulnerabilities-exposed---act-now/">numerous software vulnerabilities</a>{" "}
            that can be easily exploited by bad actors utilizing AI models like Claude Mythos.
          </p>
          <p>
            So even if the entire server infrastructure of an application were
            to be taken over by a malicious entity (including the authentication
            system), all users' data still stays safe. On the other hand, if a
            thief has stolen a user's password (e.g. through a phishing attack){" "}
            <i>and</i> also gained access to the user's email account as well as
            SMS, even then that user's account stays protected. Conversely, we
            can also enable secure account recovery in case a user has forgotten
            their own password, in spite of the fact that the user data is kept
            end-to-end encrypted with no access for the server!.
          </p>
          <div className="request-section">
            <div className="request-button">
              <a
                target="_blank"
                // href="https://sheltered-bastion-24761.herokuapp.com/"
                href="https://webrtc-updated-server-app3-072eee61b94d.herokuapp.com/"
              >
                <button>Try Demo Yourself</button>
              </a>
            </div>
            <div className="request-button">
              <button onClick={props.executeScroll}>Request Live Demo</button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Intro;
